/**
 * Generated by orval 🍺
 * Do not edit manually.
 * dashboard-data-microservice
 * OpenAPI spec version: 1.0.0
 */
export const BusinessUnitsEnum = {
    DriveToStore: 'DriveToStore',
    AppMarketing: 'AppMarketing',
};
